/**
 * violex-offer.js — Zentrale Angebots-Erkennung.
 *
 * Fragt den zum Store passenden Worker (window.VIOLEX_WORKER_URL, gesetzt in
 * layout/theme.liquid aus settings.worker_base_url) nach dem aktiven Angebot
 * (violex_offer-Metaobjekt, das in der Admin-App angelegt wird). Nur wenn ein
 * Angebot AKTIV und "visible_on_site" ist, wird die Angebots-Darstellung im
 * Shop freigeschaltet:
 *   - <html> bekommt die Klasse "violex-offer-active"
 *   - window.VIOLEX_OFFER enthält das Angebot (sonst null)
 *   - Event "violex:offer:ready" wird gefeuert
 *
 * Dadurch erscheint Angebots-Marketing (Badges, Warenkorb-Banner, Keychain-Upsell)
 * AUSSCHLIESSLICH, wenn das Angebot in der Admin-App erstellt/aktiviert wurde.
 */
(function () {
  'use strict';

  // Fallback nur falls das Setting mal fehlt (z.B. sehr altes Theme-Snapshot
  // ohne worker_base_url) - identisch zur frueheren hart codierten URL.
  var WORKER = window.VIOLEX_WORKER_URL || 'https://violex-elite-api-prod.violexclo-elite.workers.dev';

  function apply(offer) {
    var displayable = !!(offer && offer.visibleOnSite);
    window.VIOLEX_OFFER = displayable ? offer : null;
    window.VIOLEX_OFFER_READY = true;
    if (displayable) {
      document.documentElement.classList.add('violex-offer-active');
    }
    document.dispatchEvent(
      new CustomEvent('violex:offer:ready', { detail: { offer: window.VIOLEX_OFFER } }),
    );
  }

  fetch(WORKER + '/offers/active')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) { apply(d && d.ok ? d.offer : null); })
    .catch(function () { apply(null); });
})();
